<template>
  <bottom-bar-layout v-if="loaded"
                     class="page-birthday-2021"
                     :show-bar="showBar"
                     :bar-height="140"
                     :shadow="false"
  >
    <ym-img class="page-birthday-2021-header"
            :src="require('@/pages/2021/Birthday/assets/img/banner.png')"
    />
    <count-down v-if="render.countDown.show"
                class="count-down"
                :start="render.countDown.currentTime"
                :end="render.countDown.endTime"
                :block-bg-img="countDownBlockBgImg"
                :item-bg-img="countDownItemBgImg"
                :item-bottom="66"
                :left-text="render.countDown.type === 'start' ? '还有' : '仅剩'"
                num-color="#3e4656"
                text-color="#116062"
                @count-down-ended="render.countDown.show = false"
    />
    <ym-img v-if="liveList"
            class="page-birthday-2021-activity-title first"
            :src="require('@/pages/2021/Birthday/assets/img/activity_title_1.png')"
    />
    <live-list :live-list="liveList" />
    <ym-img class="page-birthday-2021-activity-title"
            :src="require('@/pages/2021/Birthday/assets/img/activity_title_2.png')"
    />
    <ym-img :src="require('@/pages/2021/Birthday/assets/img/entity_39_top.png')"
            v-ym-report:ANNIVERSARY_2021_MBA_EXPOSE=""
    />
    <router-link to="https://m.youthmba.com/entity/39"
                 v-ym-report:ANNIVERSARY_2021_MBA_BUTTON_CLICK=""
    >
      <ym-img :src="require('@/pages/2021/Birthday/assets/img/entity_39_bottom.png')" />
    </router-link>
    <ym-img class="page-birthday-2021-activity-title"
            :src="require('@/pages/2021/Birthday/assets/img/activity_title_3.png')"
    />
    <ym-img :src="require('@/pages/2021/Birthday/assets/img/combo_course_188_top.png')"
            v-ym-report:ANNIVERSARY_2021_LIVING_COURSE_EXPOSE=""
    />
    <router-link to="https://m.youthmba.com/combo/course/188"
                 v-ym-report:ANNIVERSARY_2021_LIVING_COURSE_BUTTON_CLICK=""
    >
      <ym-img :src="require('@/pages/2021/Birthday/assets/img/combo_course_188_bottom.png')" />
    </router-link>
    <ym-img :src="require('@/pages/2021/Birthday/assets/img/vip_1_top.png')"
            v-ym-report:ANNIVERSARY_2021_VIP_EXPOSE=""
    />
    <router-link to="https://m.youthmba.com/vip/1"
                 v-ym-report:ANNIVERSARY_2021_VIP_BUTTON_CLICK=""
    >
      <ym-img :src="require('@/pages/2021/Birthday/assets/img/vip_1_bottom.png')" />
    </router-link>
    <ym-img class="page-birthday-2021-activity-title"
            :src="require('@/pages/2021/Birthday/assets/img/activity_title_4.png')"
            v-ym-report:ANNIVERSARY_2021_ACTIVITY_FIVE_EXPOSE=""
    />
    <router-link to="https://m.youthmba.com/project/176"
                 v-ym-report:ANNIVERSARY_2021_PROJECT_ASTRONAUT_PLAN_BOTTUN_CLICK=""
    >
      <ym-img :src="require('@/pages/2021/Birthday/assets/img/project_176.png')" />
    </router-link>
    <router-link to="https://m.youthmba.com/project/177"
                 v-ym-report:ANNIVERSARY_2021_PROJECT_HARRY_PORTER_WORKSHOP_JANUARY_EIGHTTEN_BUTTON_CLICK=""
    >
      <ym-img :src="require('@/pages/2021/Birthday/assets/img/project_177.png')" />
    </router-link>
    <ym-img class="page-birthday-2021-activity-title"
            :src="require('@/pages/2021/Birthday/assets/img/activity_title_5.png')"
            v-ym-report:ANNIVERSARY_2021_ACTIVITY_SIX_EXPOSE=""
    />
    <div class="entity-container">
      <router-link class="entity-container-item"
                   to="https://m.youthmba.com/entity/5"
                   v-ym-report:ANNIVERSARY_2021_ENTITY_XUXUDUODUO_BUTTON_CLICK=""
      >
        <ym-img :src="require('@/pages/2021/Birthday/assets/img/entity_5.png')" />
      </router-link>
      <router-link class="entity-container-item"
                   to="https://shop405880.m.youzan.com/wscgoods/detail/3f1is5wzozinkzl?scan=1&activity=none&from=kdt&qr=directgoods_965389310&shopAutoEnter=1&showsku=true"
                   v-ym-report:ANNIVERSARY_2021_ENTITY_QUALITY_TIMES_BUTTON_CLICK=""
      >
        <ym-img :src="require('@/pages/2021/Birthday/assets/img/youzan_xsg.png')" />
      </router-link>
      <div class="entity-container-gird">
        <router-link class="entity-container-gird-item"
                     to="https://m.youthmba.com/entity/8"
                     v-ym-report:ANNIVERSARY_2021_ENTITY_ALL_THINGS_BUTTON_CLICK=""
        >
          <ym-img :src="require('@/pages/2021/Birthday/assets/img/entity_8.png')" />
        </router-link>
        <router-link class="entity-container-gird-item"
                     to="https://m.youthmba.com/entity/13"
                     v-ym-report:ANNIVERSARY_2021_ENTITY_YOUNG_BUTTON_CLICK=""
        >
          <ym-img :src="require('@/pages/2021/Birthday/assets/img/entity_13.png')" />
        </router-link>
        <router-link class="entity-container-gird-item"
                     to="https://shop405880.m.youzan.com/wscgoods/detail/2op2x1mgdbro0wa?scan=1&activity=none&from=kdt&qr=directgoods_964477867&shopAutoEnter=1"
                     v-ym-report:ANNIVERSARY_2021_ENTITY_YOUNG_MBA_CLICK=""
        >
          <ym-img :src="require('@/pages/2021/Birthday/assets/img/youzan_ss.png')" />
        </router-link>
        <router-link class="entity-container-gird-item"
                     to="https://shop405880.m.youzan.com/wscgoods/detail/1yiqvm0cppe80qp?scan=1&activity=none&from=kdt&qr=directgoods_965475539&shopAutoEnter=1"
                     v-ym-report:ANNIVERSARY_2021_ENTITY_THE_WORLD_IS_OUR_CLASS_CLICK=""
        >
          <ym-img :src="require('@/pages/2021/Birthday/assets/img/youzan_sj.png')" />
        </router-link>
      </div>
      <router-link class="entity-container-footer"
                   to="https://m.youthmba.com/marketing/common/activity/youxian"
                   v-ym-report:ANNIVERSARY_2021_BRANCH_ENTITY_LIST_CLICK=""
      >
        查看更多杂志好书及周边>
      </router-link>
    </div>
    <message-block class="message-block"
                   :count="messageCount"
                   @focus="showBar = false"
                   @blur="showBar = true"
    />
    <div class="footer">
      <div class="rule">
        <div class="rule-header">{{ rule.title }}</div>
        <div v-for="(item, index) in rule.content"
             :key="index"
             class="rule-item"
        >
          {{ index + 1 }}. {{ item }}
        </div>
      </div>
      <router-link :to="downloadLink"
                   v-ym-report:ANNIVERSARY_2021_DOWNLOAD_APP_CLICK=""
      >
        <ym-img :src="require('@/pages/2021/Birthday/assets/img/footer.png')" />
      </router-link>
    </div>
    <contact-us-bar slot="tabbar"
                    top-color="#1dcbc8"
                    bottom-color="#359f9d"
                    text-color="#ffffff"
                    @wechat="showWechatContact = true"
    />
    <qr-code-popup :show.sync="showWechatContact"
                   :title="'如有疑问欢迎扫码<br>添加老师进行咨询'"
                   :qrcode="require('@/pages/2021/Birthday/assets/img/wechat_contact.jpg')"
    />
    <ended-popup :show="showEndedPopup"
                 :close="true"
    />
  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import CountDown from '@/components/CountDown';
  import QrCodePopup from '@/components/QrCodePopup';
  import EndedPopup from '@/pages/2021/Birthday/components/EndedPopup';
  import ContactUsBar from '@/pages/2021/Birthday/components/ContactUsBar';
  import MessageBlock from '@/pages/2021/Birthday/components/MessageBlock';
  import LiveList from '@/pages/2021/Birthday/components/LiveList';
  import { loginRegisterWithMobile } from '@/services/app';
  import { getBirthdayInfo } from '@/services/birthday-2021';

  export default {
    name: 'Birthday2021',
    components: {
      BottomBarLayout,
      EndedPopup,
      ContactUsBar,
      QrCodePopup,
      MessageBlock,
      CountDown,
      LiveList,
    },
    data() {
      return {
        loaded: false,
        showEndedPopup: false,
        showWechatContact: false,
        render: {},
        rule: {},
        downloadLink: 'https://m.youthmba.com/download/app',
        liveList: null,
        showBar: true,
        messageCount: 1100,
      };
    },
    computed: {
      /* eslint-disable global-require */
      countDownBlockBgImg() {
        if (this.render.countDown.type === 'start') return require('@/pages/2021/Birthday/assets/img/count_down_block_start.png');
        return require('@/pages/2021/Birthday/assets/img/count_down_block_end.png');
      },
      countDownItemBgImg() {
        return require('@/pages/2019/Birthday/assets/img/cound_down_item.png');
      },
      /* eslint-enable global-require */
    },
    methods: {
      async fetchData() {
        const data = await getBirthdayInfo();
        this.render = data.render;
        this.rule = data.rule;
        this.liveList = data.liveList;
        this.loaded = true;
        if (this.render.pageTitle) document.title = this.render.pageTitle;
        if (this.render.status === 'ended') {
          setTimeout(() => {
            this.showEndedPopup = true;
          }, 0);
        }
        if (this.render.countDown) {
          const { currentTime } = this.render.countDown;
          const days = parseInt((currentTime - 1635436800) / 86400, 10);
          this.messageCount += days * 500;
        }
      },
      async handleLogin(e) {
        try {
          await loginRegisterWithMobile({
            mobile: e.mobile,
            sms_code: e.sms_code,
            sms_type: 'verify',
          });
          await this.fetchData();
        } catch (err) {
          console.log(err);
        }
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-birthday-2021 {
    width: 100%;
    /deep/ img {
      width: 100%;
      display: block;
    }
    line-height: 0;
    min-height: 100%;
    background: #188e9f;
    &-activity-title {
      margin: 120px 0 43px;
      &.first {
        margin-top: 0;
      }
    }
  }

  .count-down {
    position: relative;
    top: -150px;
    z-index: @z-index-large;
  }

  /deep/ .count-down-content {
    bottom: 120px !important;
  }

  .message-block {
    margin-top: 120px;
  }

  .entity-container {
    width: 100%;
    height: 2000px;
    background: url('~@/pages/2021/Birthday/assets/img/activity_5_bg.png');
    background-size: 100% 100%;
    padding-top: 76px;
    box-sizing: border-box;
    &-item {
      display: block;
      margin-bottom: 20px;
    }
    &-gird {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 50px;
      &-item {
        margin-bottom: 20px;
        /deep/ img {
          width: 323px;
          height: 500px;
        }
      }
    }
    &-footer {
      display: block;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 30px;
      text-decoration: underline;
      margin-top: 50px;
    }
  }

  .footer {
    margin-top: 50px;
    .rule {
      display: flex;
      flex-direction: column;
      padding: 75px 80px;
      &-header {
        color: #fff;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 33px;
      }
      &-item {
        color: #fff;
        font-size: 26px;
        line-height: 46px;
      }
    }
  }
</style>
